<nimbus-filter-summary-button
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  [summary]="summary"
  [filterName]="filter.name"
  [disabled]="disabled"
  [isValueEmpty]="isValueEmpty"
  [hasError]="hasError"
  (summaryClick)="onSummaryClick()"
  (removeFilter)="onRemoveFilter()"
></nimbus-filter-summary-button>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayPanelClass="nimbus-filter-datetime-connected-overlay"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayPositions]="cdkConnectedPositions"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayOpen]="isOpen$ | async"
  (detach)="onDetach()"
  (overlayOutsideClick)="onOutsideClick($event)"
>
  <div class="nimbus-tooltip-complex flex-container tooltip-content">
    <div class="duration-controls">
      <nimbus-filter-datetime-range-input
        [minDate]="minDate"
        [maxDate]="maxDate"
        [dateFormat]="filter.dateFormat"
        [timeFormat]="filter.timeFormat"
        [locale]="locale"
        [formControl]="formControl"
        [quickActions]="filter.quickActions"
      ></nimbus-filter-datetime-range-input>
    </div>
  </div>
</ng-template>
